import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    allBillingInvoices: [],
    allBillingInvoicesLoading: false,
    allParkingInvoices: [],
    allParkingInvoicesLoading: false,
    fields: {
      ALL_BILLING_INVOICES: `
        id
        customer {
          id
          company_name
        }
        order {
          id
          order_no
        }
        invoice_no
        sent_at
        re_sent_at
        sent_to
        credit_invoice_no
        due_date
        paid_at
        total_price
        total_price_ex_vat
        currency
        internal_notes
        created_at
        is_credit_invoice
      `,
      ALL_PARKING_INVOICES: `
        id
        customer_id
        invoice_no
        status
        sent_at
        sent_to
        is_paid
        total_price_in_cents_with_vat
        total_price_in_cents_ex_vat
        currency
        billing_company_name
        billing_user_name
        created_at
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getAllBillingInvoices(state) {
    return state.allBillingInvoices;
  },
  getAllBillingInvoicesLoading(state) {
    return state.allBillingInvoicesLoading;
  },
  getAllParkingInvoices(state) {
    return state.allParkingInvoices;
  },
  getAllParkingInvoicesLoading(state) {
    return state.allParkingInvoicesLoading;
  }
};

const actions = {
  fetchAllParkingInvoices({ commit, dispatch, state }) {
    commit("setAllParkingInvoicesLoading", true);

    const data = {
      query: `
        query {
          allParkingInvoices(limit: 20) { ${state.fields.ALL_PARKING_INVOICES} }
        }
      `
    };
    const data_1 = {
      query: `
        query {
          allParkingInvoices(offset: 20) { ${state.fields.ALL_PARKING_INVOICES} }
        }
      `
    };

    dispatch("fetchParkingInvoices", {
      data: data,
      commit_to: "setAllParkingInvoices"
    }).then(() => {
      dispatch("fetchParkingInvoices", {
        data: data_1,
        commit_to: "setAddToAllParkingInvoices"
      }).then(() => {
        commit("setAllParkingInvoicesLoading", false);
      });
    });
  },
  fetchParkingInvoices({ commit, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            let parking_invoices = res.data.data.allParkingInvoices.map(
              invoice => {
                return {
                  id: invoice.id,
                  customer_id: invoice.customer_id,
                  invoice_no: invoice.invoice_no,
                  status: invoice.status,
                  sent_at: invoice.sent_at == null ? "" : invoice.sent_at,
                  sent_to: invoice.sent_to == null ? "" : invoice.sent_to,
                  is_paid: invoice.is_paid,
                  currency: invoice.currency,
                  total_price: invoice.total_price_in_cents_with_vat,
                  total_price_ex_vat: invoice.total_price_in_cents_ex_vat,
                  company_name: invoice.billing_company_name,
                  user_name: invoice.billing_user_name,
                  created_at: invoice.created_at,
                  _showDetails: false
                };
              }
            );

            commit(payload.commit_to, parking_invoices);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          resolve();
        });
    });
  },
  fetchBillingInvoicesPagination({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            billingInvoices: billingInvoicesPagination (
              limit: ${payload.limit},
              offset: ${payload.offset},
              order: "${payload.order}"
            ) { ${state.fields.ALL_BILLING_INVOICES} }
          }
        `
      }
    };

    dispatch("fetchCommitBillingInvoices", commitPayload);
  },
  fetchBillingInvoicesLikeInvoiceNo({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            billingInvoices: billingInvoicesLikeInvoiceNo(
              invoice_no: "${payload.invoice_no}"
            ) {
              ${state.fields.ALL_BILLING_INVOICES}
            }
          }
        `
      }
    };

    dispatch("fetchCommitBillingInvoices", commitPayload);
  },
  fetchBillingInvoicesLikeCustomerName({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            billingInvoices: billingInvoicesLikeCustomerName(
              customer_name: "${payload.customer_name}"
            ) {
              ${state.fields.ALL_BILLING_INVOICES}
            }
          }
        `
      }
    };

    dispatch("fetchCommitBillingInvoices", commitPayload);
  },
  fetchBillingInvoicesBySentAtRange({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query billingInvoicesBySentAtRange($sent_from: String, $sent_to: String) {
            billingInvoices: billingInvoicesBySentAtRange(sent_from: $sent_from, sent_to: $sent_to) {
              ${state.fields.ALL_BILLING_INVOICES}
            }
          }
        `,
        variables: {
          sent_from: payload.sent_from,
          sent_to: payload.sent_to
        },
      }
    };

    dispatch("fetchCommitBillingInvoices", commitPayload);
  },
  fetchCommitBillingInvoices({ state, commit, rootGetters, dispatch }, payload) {
    return new Promise((resolve) => {
      commit("setAllBillingInvoicesLoading", true);

      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              // Check for timeout error to logout
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("axios_mod/makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              }, { root: true });
            });
            resolve(false);
          } else {
            commit('setAllBillingInvoices', res.data.data.billingInvoices);
            resolve();
          }
        })
        .catch(err => {
          dispatch("axios_mod/makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          }, { root: true });
          resolve(false);
        })
        .finally(() => { commit("setAllBillingInvoicesLoading", false) });
    });
  },
};

const mutations = {
  setAllBillingInvoices(state, billingInvoices) {
    state.allBillingInvoices = billingInvoices || [];
  },
  setAllBillingInvoicesLoading(state, loading) {
    state.allBillingInvoicesLoading = loading;
  },
  setAllParkingInvoices(state, invoices) {
    state.allParkingInvoices = invoices;
  },
  setAddToAllParkingInvoices(state, invoices) {
    state.allParkingInvoices.push(...invoices);
  },
  setAllParkingInvoicesLoading(state, loading) {
    state.allParkingInvoicesLoading = loading;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
